"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = alert;
exports.alertOnError = alertOnError;
const error_stack_parser_1 = __importDefault(require("error-stack-parser"));
const server_1 = require("../server");
const LOGR_CLIENT_SIDE_URL = 'https://www.deviantart.com/_puppy/util/ddt';
const LOGR_CLIENT_SIDE_URL_LOCAL = 'https://www.deviantart.lan/_puppy/util/ddt';
function alert(name, message, tags, data) {
    if ((0, server_1.isSSR)() || window.hasOwnProperty('__DDT_UNSUPPORTED_BROWSER')) {
        return;
    }
    const payload = {
        error: message,
        data: {
            browser: {
                userAgent: navigator && navigator.userAgent,
                location: location && location.href,
                referrer: document && document.referrer,
            },
            app: (window && window['__APP_INFO__']) || 'unknown',
            ...data,
        },
        tags: [...tags, (window && window['__APP_INFO__'])],
    };
    let endpoint = LOGR_CLIENT_SIDE_URL;
    if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
        endpoint = `${window.location.origin}/_puppy/util/ddt`;
    }
    else if (window['__XHR_LOCAL__']) {
        endpoint = LOGR_CLIENT_SIDE_URL_LOCAL;
    }
    const xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({ payload }));
}
/** Parses the backtrace from an error and includes it in the logr post `data` */
function alertOnError(error, name, message, tags, data = {}) {
    return alert(name, message, tags, {
        stacktrace: error && error_stack_parser_1.default.parse(error),
        ...data,
    });
}
//# sourceMappingURL=alert.js.map